exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.confirm-dialog[data-v-46fb10e0] {\n  border-radius: 10px;\n}\n", ""]);

